const timelineYears = document.querySelectorAll('.timeline li h2');
const timelineImages = document.querySelectorAll('.timeline__image');
const scrollTopBtn = document.querySelector('.timeline__scroll-top');

const observerOptions = { threshold: 0.3 };

const observerCallback = (entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('is-visible');
		} else {
			entry.target.classList.remove('is-visible');
		}
	});
};

if (timelineYears.length) {
	const yearObserver = new IntersectionObserver(observerCallback, { threshold: 0.5 });
	timelineYears.forEach((el) => yearObserver.observe(el));
}

if (timelineImages.length) {
	const imageObserver = new IntersectionObserver(observerCallback, observerOptions);
	timelineImages.forEach((el) => imageObserver.observe(el));
}

if (scrollTopBtn) {
	scrollTopBtn.addEventListener('click', () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});
}
